<template>
  <div class="form-column">
    <div class="label text-smaller text-bold text-uppercase">
      Line {{ index + 1 }}
    </div>
    <div class="flex flex-wrap-nowrap flex-align-center" style="margin-top: 0.25em;">
      <input
        class="input-field"
        style="padding-right: 1.75em;"
        type="text"
        value="AIN Last 5 (Assigned)"
        readonly>
      <svg class="block text-muted" style="margin-left: -24px;" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <use href="#input-lock-icon"></use>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    line: {
      required: true,
      type: Object,
    },
    ain: {
      default: '12345',
      type: String,
    },
  },
}
</script>
